var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"overlay"}},[(_vm.show)?_c('div',{class:'overlay ' + (_vm.transparent ? 'transparent' : ''),on:{"click":function($event){_vm.click && _vm.click()}}},[_c('div',{staticClass:"inner",style:({ opacity: _vm.opacity })})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.5.0@vue-loader/lib/template-compiler?{"id":"data-v-03b0096d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.5.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/overlay/index.vue
// module id = null
// module chunks = 